import { PreviewFrame } from "./PreviewFrame";

const LEADS_BY_SOURCE: { label: string; share: number; color: string }[] = [
  { label: "Zillow", share: 92, color: "#e6007e" },
  { label: "Contact form", share: 71, color: "#00a7de" },
  { label: "Apartments.com", share: 54, color: "#52c535" },
  { label: "Walk-in", share: 33, color: "#f2c94c" },
  { label: "Referral", share: 18, color: "#f2994a" }
];

const CONVERSION_BY_STAGE: { label: string; height: number }[] = [
  { label: "New", height: 100 },
  { label: "Contacted", height: 78 },
  { label: "Tour", height: 52 },
  { label: "Applied", height: 31 },
  { label: "Leased", height: 17 }
];

/**
 * Teaser for the locked BoomCRM analytics tab: a leads-by-source bar list next
 * to a conversion-by-stage funnel. No dedicated Figma frame exists for this
 * paywall — the layout follows the analytics dashboard's own cards.
 */
export const AnalyticsPreview = () => (
  <PreviewFrame>
    <div className="flex h-full w-full divide-x divide-alpha-40">
      {/* Leads by source */}
      <div className="flex w-1/2 flex-col gap-3 px-6 py-5">
        <p className="text-[13px] font-bold leading-[18px] text-content-1000">
          Leads by source
        </p>
        <div className="flex flex-col gap-[10px]">
          {LEADS_BY_SOURCE.map((row) => (
            <div key={row.label} className="flex items-center gap-3">
              <span className="w-[92px] shrink-0 truncate text-[12px] font-medium leading-4 text-content-400">
                {row.label}
              </span>
              <div className="h-2 flex-1 overflow-hidden rounded-full bg-alpha-40">
                <div
                  className="h-full rounded-full"
                  style={{ width: `${row.share}%`, backgroundColor: row.color }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Conversion by stage */}
      <div className="flex w-1/2 flex-col gap-3 px-6 py-5">
        <p className="text-[13px] font-bold leading-[18px] text-content-1000">
          Conversion by stage
        </p>
        <div className="flex flex-1 items-end gap-3">
          {CONVERSION_BY_STAGE.map((bar, idx) => (
            <div
              key={bar.label}
              className="flex h-full flex-1 flex-col items-center justify-end gap-2"
            >
              <div
                className="w-full rounded-t-md"
                style={{
                  height: `${bar.height}%`,
                  backgroundColor: idx === 0 ? "#e6007e" : "#f7c3df",
                  opacity: 1 - idx * 0.12
                }}
              />
              <span className="truncate text-[11px] font-medium leading-4 text-content-400">
                {bar.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </PreviewFrame>
);
